export enum TipoExportacao {	
    CSV = 1,
    PDF = 2
}


// WEBPACK FOOTER //
// ./src/app/shared/filter/enum-tipo-exportacao.ts